import { normalize } from './format';

/**
 * Regras automáticas de pré-moderação. As mesmas verificações são aplicadas
 * no banco de dados antes de cada publicação, para que nada dependa do navegador.
 */
const BLOCKED_TERMS = ['ganhe dinheiro facil', 'renda garantida', 'piramide', 'pix antecipado', 'deposito antecipado', 'clique aqui agora'];

export const MODERATION_RULES = [
  { id: 'fraude', title: 'Fraudes e golpes', text: 'Proibido solicitar pagamentos antecipados suspeitos, prometer retorno garantido, esquemas de pirâmide ou se passar por outra empresa.' },
  { id: 'spam', title: 'Spam', text: 'Publicações repetidas, excesso de links, textos em caixa-alta ou sem relação com negócios são removidos.' },
  { id: 'assedio', title: 'Assédio e ameaças', text: 'Não toleramos intimidação, ameaças, exposição de dados pessoais ou abordagens insistentes após recusa.' },
  { id: 'discriminacao', title: 'Discriminação', text: 'Conteúdos que discriminem pessoas por origem, cor, religião, sexo, idade ou deficiência são removidos e a conta pode ser suspensa.' },
  { id: 'veracidade', title: 'Veracidade', text: 'Informações comerciais devem ser verdadeiras. O CNPJ é validado na Receita Federal, e o selo de verificado só é concedido após essa validação. A checagem documental completa será ativada em breve.' },
  { id: 'privacidade', title: 'Privacidade', text: 'Dados de contato só são exibidos quando a própria empresa autoriza a publicação.' },
];

/** @returns {{ok:boolean, flags:string[]}} */
export function precheckContent({ title = '', description = '' }) {
  const flags = [];
  const text = normalize(`${title} ${description}`);
  if (BLOCKED_TERMS.some((t) => text.includes(t))) flags.push('Possível conteúdo fraudulento');
  const links = (description.match(/https?:\/\//g) || []).length;
  if (links > 2) flags.push('Excesso de links');
  const letters = title.replace(/[^A-Za-zÀ-ú]/g, '');
  if (letters.length > 8 && letters === letters.toUpperCase()) flags.push('Título em caixa-alta');
  return { ok: flags.length === 0, flags };
}